module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/itemsGroups/itemsGroups-show/itemsGroups-show.component.scss
// module id = ./src/app/views/setting/itemsGroups/itemsGroups-show/itemsGroups-show.component.scss
// module chunks = main